import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { StarIcon } from 'lucide-react'

import { AppsFooter } from './apps-footer'

export const Rating = ({
	defaultValue,
	className,
}: {
	defaultValue: number
	className?: string
}) => {
	// const valueRoundedToLowerHalf = Math.floor(defaultValue * 2) / 2

	return (
		<div className={cn('flex gap-x-0.5', className)}>
			{Array.from({ length: 5 }, (_, i) => {
				const diff = Math.max(Math.min(defaultValue - i, 1), 0)
				// const diff = Math.min(Math.abs(i - valueRoundedToLowerHalf), 1)

                return (
					<div
						className='relative'
						key={i}
					>
						<div
							className='absolute overflow-hidden'
							style={{
								width: i < defaultValue ? `${100 * diff}%` : 0,
							}}
						>
							<StarIcon
								className='fill-primary stroke-primary'
								strokeWidth={0}
							/>
						</div>

						<StarIcon
							className='fill-muted/30 stroke-muted/30'
							strokeWidth={0}
						/>
					</div>
				)
			})}
		</div>
	)
}

export const BaselineAndRating = () => {
	const { t } = useLingui()

	return (
		<div className='flex flex-col gap-6'>
			<div className='flex flex-col gap-2 leading-none'>
				<p className='text-primary text-[30px] font-bold'>cocoon space</p>
				<p>{t`Location de bureaux à Paris et Lyon`}</p>

				<div className='flex items-center text-sm'>
					4,8
					<Rating
						className='mx-2'
						defaultValue={4.8}
					/>
					<a
						className='text-slate-500'
						href='https://www.google.com/maps/search/cocoon+space/@48.8665006,2.306261,13z?entry=ttu'
						rel='noreferrer'
						target='_blank'
					>
						449 avis
					</a>
				</div>
			</div>

			<AppsFooter />
		</div>
	)
}
